/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentMethodType } from './paymentMethodType';
import { TransactionType } from './transactionType';
import { TransactionDiscountInfo } from './transactionDiscountInfo';


export interface TransactionDetailDto { 
    id?: number;
    creationTime?: string;
    locationId?: number;
    locationCode?: string | null;
    locationRateDisplayName?: string | null;
    rate?: number;
    taxAmount?: number;
    serviceFeeAmount?: number;
    discountAmount?: number;
    totalAmount?: number;
    discountInfo?: Array<TransactionDiscountInfo> | null;
    readonly discountCodes?: string | null;
    readonly signedRate?: number;
    readonly signedTaxAmount?: number;
    readonly signedServiceFeeAmount?: number;
    readonly signedDiscountAmount?: number;
    readonly signedTotalAmount?: number;
    cardHolderName?: string | null;
    paymentMethodType?: PaymentMethodType;
    readonly paymentMethodTypeFormatted?: string | null;
    gatewayTransactionId?: string | null;
    gatewayResponse?: string | null;
    gatewayResponseCode?: string | null;
    isSuccess?: boolean;
    readonly isSuccessFormatted?: string | null;
    transactionType?: TransactionType;
    readonly transactionTypeFormatted?: string | null;
    originalTransactionId?: number | null;
    isRefunded?: boolean;
}
export namespace TransactionDetailDto {
}


